import { DocsFooter, DocsLayoutView } from '@/features/docs';
import { ScrollToTop } from '@/app/layouts/utils/ScrollToTop.tsx';
import { ScrollToHash } from '@/app/layouts/utils/ScrollToHash.tsx';
import { RouteLoadingOverlay } from '@/app/layouts/utils/RouteLoadingOverlay.tsx';

/**
 * 문서 상세(`/docs/:section`, `/docs/:section/:slug`) 전용 레이아웃.
 *
 * `MainLayout` 을 쓰지 않는다 — 헤더가 다르다(`DocsHeader`). 대신 라우트 유틸은
 * 그대로 가져온다. 특히 `ScrollToHash` 는 목차(TOC) 링크가 동작하는 근거라
 * 빠지면 문서 안 이동이 통째로 죽는다.
 *
 * 푸터도 `DocsFooter` 로 갈랐다 — 문서를 다 읽은 자리에 사업자 정보 한 뭉치가
 * 붙으면 정작 필요한 다음 행동(문의)이 아래로 밀린다.
 *
 * ⚠️ `MainLayout` 의 `usePostLoginVerificationRedirect()` 는 의도적으로 뺐다.
 *    로그인 직후 미검증 기업 계정을 기업검증 화면으로 보내는 훅인데, 도움말을
 *    읽으러 들어온 사람을 도중에 끌어내는 건 맞지 않는다. 검증 유도는 대시보드·
 *    스토어 등 `MainLayout` 화면에서 계속 걸린다.
 */
export default function DocsLayout() {
  return (
    <>
      <ScrollToTop />
      <ScrollToHash />
      <RouteLoadingOverlay />
      <DocsLayoutView />
      <DocsFooter />
    </>
  );
}
